const getters = {
  loading: state => state.app.loading,
  refreshTs: state => state.app.refreshTs,
  isDebuggingBillingRule: state => state.app.isDebuggingBillingRule
}
export default getters
